/* Morocconia theme script.
   The rack (garments turn on hover, close-up with front and back), the product quick view,
   colourway swatches, shop filters and the bag drawer on Shopify's AJAX cart.
   Product data comes from <script type="application/json" data-mrk-products> blocks rendered by the sections. */
(() => {
'use strict';

const $ = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];
const cfgEl = document.getElementById('mrk-config');
if (!cfgEl) return;
let CFG = {};
try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
const T = {};
const ROUTES = CFG.routes || {};
const lang = String(CFG.locale || 'en').slice(0, 2).toLowerCase();

const t = (k, vars) => {
  let s = T[k] ?? k;
  if (vars) for (const [a, b] of Object.entries(vars)) s = s.split(`{{ ${a} }}`).join(b).split(`{{${a}}}`).join(b);
  return s;
};
const AR = '٠١٢٣٤٥٦٧٨٩';
const dg = s => lang === 'ar' ? String(s).replace(/\d/g, d => AR[d]) : String(s);
const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[c]);
const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
const hoverable = () => matchMedia('(hover: hover) and (pointer: fine)').matches;
const easeIO = x => x < .5 ? 4*x*x*x : 1 - Math.pow(-2*x + 2, 3) / 2;

/* ---------- money, in the shop's own format ---------- */
function decode(s){ const d = document.createElement('textarea'); d.innerHTML = s; return d.value; }
for (const [k, v] of Object.entries(CFG.t || {})) T[k] = decode(String(v));
const MONEY_FORMAT = decode(String(CFG.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, ''));
const OTHER_CURRENCY = CFG.currency && CFG.shopCurrency && CFG.currency !== CFG.shopCurrency;
function money(cents){
  cents = Math.round(Number(cents) || 0);
  if (OTHER_CURRENCY){   // shopping in another market currency: let the browser format it
    try { return dg(new Intl.NumberFormat(document.documentElement.lang || 'en', { style:'currency', currency: CFG.currency }).format(cents / 100)); } catch (e) { /* fall through */ }
  }
  const fmt = (dec, th = ',', dp = '.') => {
    const [i, f] = (cents / 100).toFixed(dec).split('.');
    return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? dp + f : '');
  };
  const out = MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
    amount: fmt(2), amount_no_decimals: fmt(0),
    amount_with_comma_separator: fmt(2, '.', ','), amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
    amount_with_apostrophe_separator: fmt(2, "'", '.'), amount_no_decimals_with_space_separator: fmt(0, ' '),
    amount_with_space_separator: fmt(2, ' ', ','), amount_with_period_and_space_separator: fmt(2, ' ', '.')
  })[k] ?? fmt(2));
  return dg(out);
}

/* ---------- products ---------- */
const BY = {};
const isSize = n => /size|taille|talla|größe|groesse|مقاس/i.test(n || '');
const isColour = n => /colou?r|couleur|farbe|لون/i.test(n || '');
function addProduct(r){
  if (!r || !r.handle || BY[r.handle]) return;
  const opts = r.options || [];
  const single = typeof r.single === 'boolean' ? r.single : (r.variants || []).length <= 1 && (!opts.length || (opts.length === 1 && /^title$/i.test(opts[0])));
  const sizeOnly = opts.length === 1 && isSize(opts[0]);
  const ci = opts.findIndex(isColour);
  const v = (r.variants || []).map(x => ({
    id: x.id, available: !!x.available, price: x.price, img: x.img, opts: x.options || [], full: x.title,
    label: single ? '' : (sizeOnly && CFG.shortSizes !== false) ? (String(x.title).split(/\s+/)[0] || x.title) : String(x.title).replace(/\s*\/\s*/g, ' / ')
  }));
  const p = {
    id: r.handle, title: r.title, url: r.url, type: r.type || '', price: r.price, available: !!r.available,
    desc: r.desc || '', images: r.images || [], v, single, sizeOnly, colour: -1, optName: opts.length === 1 ? opts[0] : opts.join(' / ')
  };
  if (ci >= 0){
    const vals = [...new Set(v.map(x => x.opts[ci]))];
    if (vals.length > 1){
      p.colour = ci;
      // photos are grouped by colourway in the same order (front, three-quarter angle, …);
      // anything left over at the end (a size chart, say) is shown with every colourway
      const n = vals.length, per = Math.max(1, Math.floor(p.images.length / n));
      const extra = []; for (let i = n * per; i < p.images.length; i++) extra.push(i);
      v.forEach(x => {
        let g = vals.indexOf(x.opts[ci]);
        if (x.img) g = Math.min(n - 1, Math.floor((x.img - 1) / per));
        const idx = []; for (let i = g * per; i < g * per + per && i < p.images.length; i++) idx.push(i);
        x.imgs = idx.concat(extra);
      });
    }
  }
  BY[p.id] = p;
}
function loadProducts(root = document){
  $$('script[data-mrk-products]', root).forEach(s => { try { (JSON.parse(s.textContent) || []).forEach(addProduct); } catch (e) { /* skip a broken block */ } });
}
loadProducts();
const variant = (p, vid) => p && p.v.find(x => x.id === Number(vid));
const findByVariant = vid => Object.values(BY).find(p => variant(p, vid));
const isPhoto = img => img && img.r > .76 && img.r < .84;

/* ---------- variant chips ---------- */
function legendFor(p){ return p.colour >= 0 ? t('colour') : p.sizeOnly ? t('size') : p.optName; }
function chips(p, name, selected){
  return `<legend class="label">${esc(legendFor(p))}</legend>` + p.v.map((x, i) => {
    const id = `${name}-${i}`;
    return `<input type="radio" name="${name}" id="${id}" value="${x.id}" ${x.available ? '' : 'disabled'} ${selected === x.id ? 'checked' : ''}>` +
           `<label for="${id}" title="${esc(x.full)}">${esc(x.label)}</label>`;
  }).join('');
}

/* ---------- bag: Shopify AJAX cart ---------- */
const Bag = {
  data: null,
  count: Number(CFG.cartCount) || 0,
  async request(url, body){
    const r = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    });
    let j = null; try { j = await r.json(); } catch (e) { /* empty */ }
    if (!r.ok) throw new Error((j && (j.description || j.message)) || t('error'));
    return j;
  },
  async fetch(){ this.data = await this.request(`${ROUTES.cart || '/cart'}.js`); this.count = this.data.item_count; return this.data; },
  async add(id, quantity = 1){ await this.request(`${ROUTES.cartAdd || '/cart/add'}.js`, { items: [{ id: Number(id), quantity }] }); return this.fetch(); },
  async change(key, quantity){ this.data = await this.request(`${ROUTES.cartChange || '/cart/change'}.js`, { id: key, quantity }); this.count = this.data.item_count; return this.data; }
};
const sized = (url, w) => !url ? '' : url + (url.includes('?') ? '&' : '?') + `width=${w}`;

async function addToBag(handle, vid, btn){
  const p = BY[handle] || findByVariant(vid), v = variant(p, vid);
  if (btn){ btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
  try {
    await Bag.add(vid, 1);
    renderBag(true);
    toast(`${t('added')}: ${p ? p.title : ''}${v && v.label ? ' · ' + v.label : ''}`, true);
  } catch (err){
    toast(err.message || t('error'), false);
  } finally {
    if (btn){
      const lost = document.activeElement === document.body || document.activeElement === btn;
      btn.disabled = false; btn.removeAttribute('aria-busy');
      if (lost && btn.isConnected) btn.focus({ preventScroll:true });
    }
  }
}

function setCount(bump){
  const c = $('#bag-count'); if (!c) return;
  c.textContent = dg(Bag.count);
  if (bump){ c.classList.add('bump'); setTimeout(() => c.classList.remove('bump'), 260); }
}
function renderBag(bump){
  setCount(bump);
  const body = $('#bag-body'), foot = $('#bag-foot'), d = Bag.data;
  if (!body || !foot || !d) return;
  if (!d.items.length){
    body.innerHTML = `<div class="bag-empty"><p>${esc(t('bag_empty'))}</p><a class="btn btn-ghost" href="${esc(ROUTES.root || '/')}#rack" data-close-go>${esc(t('bag_empty_cta'))} <span class="arrow" aria-hidden="true">→</span></a></div>`;
    foot.hidden = true; return;
  }
  foot.hidden = false;
  body.innerHTML = d.items.map(it => {
    const vt = it.product_has_only_default_variant ? '' : (it.variant_title || '');
    return `<div class="line">
      <div class="line-img">${it.image ? `<img src="${esc(sized(it.image, 240))}" alt="">` : ''}</div>
      <div><h4><a href="${esc(it.url)}" style="text-decoration:none">${esc(it.product_title)}</a></h4>${vt ? `<small>${esc(vt)}</small>` : ''}
        <div class="qty"><button type="button" data-qty="-1" data-key="${esc(it.key)}" data-q="${it.quantity}" aria-label="${esc(t('less'))}">−</button><span>${dg(it.quantity)}</span><button type="button" data-qty="1" data-key="${esc(it.key)}" data-q="${it.quantity}" aria-label="${esc(t('more'))}">+</button></div><br>
        <button class="rm" type="button" data-remove="${esc(it.key)}">${esc(t('remove'))}</button></div>
      <span class="lp">${money(it.final_line_price)}</span>
    </div>`;
  }).join('');
  foot.innerHTML = `<div class="sub"><span>${esc(t('subtotal'))}</span><span class="num">${money(d.total_price)}</span></div>
    <form action="${esc(ROUTES.cart || '/cart')}" method="post"><button class="btn btn-solid" type="submit" name="checkout" style="width:100%">${esc(t('checkout'))} <span class="arrow" aria-hidden="true">→</span></button></form>
    <p>${esc(t('bag_note'))}</p>`;
}
async function openBag(){
  const body = $('#bag-body'); if (!body) return;
  if (!Bag.data) body.innerHTML = `<p class="hint" style="padding-top:24px">${esc(t('loading'))}</p>`;
  openLayer($('#bag'));
  try { await Bag.fetch(); renderBag(); } catch (e){ body.innerHTML = `<p class="hint" style="padding-top:24px">${esc(t('error'))}</p>`; }
}
async function changeLine(key, q){
  try { await Bag.change(key, q); renderBag(true); } catch (err){ toast(err.message || t('error'), false); }
}

/* ---------- layers (sheet, bag, menu) ---------- */
let openEl = null, lastFocus = null;
function openLayer(el){
  if (!el) return;
  if (openEl && openEl !== el) closeLayer(true);
  if (openEl === el) return;
  lastFocus = document.activeElement;
  const scrim = $('#scrim');
  scrim.hidden = false; el.hidden = false;
  document.documentElement.style.overflow = 'hidden';
  requestAnimationFrame(() => requestAnimationFrame(() => { scrim.classList.add('on'); el.classList.add('on'); }));
  openEl = el;
  setTimeout(() => $('[data-close]', el)?.focus({ preventScroll:true }), 60);
}
function closeLayer(instant){
  const el = openEl; if (!el) return;
  const scrim = $('#scrim');
  scrim.classList.remove('on'); el.classList.remove('on');
  const done = () => { el.hidden = true; scrim.hidden = true; };
  if (instant) done(); else setTimeout(done, 480);
  document.documentElement.style.overflow = '';
  openEl = null;
  if (!instant && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll:true });
}
function toggleMenu(force){
  const m = $('#menu'), b = $('.menu-btn'); if (!m || !b) return;
  const on = force ?? m.hidden;
  m.hidden = !on; b.setAttribute('aria-expanded', String(on));
  b.textContent = on ? t('close') : t('menu');
  document.documentElement.style.overflow = on ? 'hidden' : '';
}

let toastTimer;
function toast(msg, withBag){
  const el = $('#toast'); if (!el) return;
  el.innerHTML = `<span>${esc(msg)}</span>${withBag ? `<button type="button" data-bag-open>${esc(t('view_bag'))}</button>` : ''}`;
  el.classList.add('on');
  clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('on'), 3200);
}

/* ---------- quick view sheet ---------- */
let sheet = { id:null, vid:null, view:0 };
function galleryFor(p, vid){
  let idx = p.images.map((_, i) => i);
  if (p.colour >= 0){ const x = variant(p, vid) || p.v.find(y => y.available) || p.v[0]; if (x && x.imgs) idx = x.imgs; }
  return idx.map(i => p.images[i]).filter(Boolean);
}
function renderSheet(){
  const p = BY[sheet.id]; if (!p) return;
  const g = galleryFor(p, sheet.vid);
  if (sheet.view >= g.length) sheet.view = 0;
  const img = g[sheet.view];
  const main = $('#g-main');
  main.className = 'g-main' + (isPhoto(img) ? ' cover' : '');
  main.innerHTML = img ? `<img src="${esc(img.src)}" alt="${esc(img.alt || p.title)}">` : '';
  $('#g-thumbs').innerHTML = g.length > 1 ? g.map((im, i) => `<button type="button" data-view="${i}" aria-current="${i === sheet.view}" aria-label="${esc(im.alt || p.title)}"><span><img class="${isPhoto(im) ? '' : 'contain'}" src="${esc(im.mini)}" alt="" loading="lazy"></span>${im.alt && im.alt !== p.title ? `<span>${esc(im.alt)}</span>` : ''}</button>`).join('') : '';
  $('#sheet-title').textContent = p.title;
  const cur = variant(p, sheet.vid);
  $('#sheet-price').textContent = money(cur ? cur.price : p.price);
  const sizes = $('#sheet-sizes');
  sizes.hidden = p.single;
  sizes.innerHTML = p.single ? '' : chips(p, 'sheet', sheet.vid);
  if (p.single && p.v[0]) sheet.vid = p.v[0].id;
  const add = $('#sheet-add');
  const avail = p.v.some(x => x.available);
  add.disabled = !sheet.vid || !avail;
  add.innerHTML = !avail ? esc(t('sold_out')) : sheet.vid ? `${esc(t('add'))} · ${money((variant(p, sheet.vid) || p).price)}` : esc(p.colour >= 0 ? t('choose_colour') : t('choose'));
  $('#sheet-desc').innerHTML = p.desc;
  const live = $('#sheet-live'); live.href = p.url;
}
function openSheet(handle, pick){
  const p = BY[handle]; if (!p) return false;
  const avail = p.v.filter(x => x.available);
  let vid = null;
  if (p.colour >= 0) vid = (avail.find(x => x.id === Number(pick)) || avail[0] || {}).id || null;
  else if (p.v.length === 1 && avail.length) vid = avail[0].id;
  sheet = { id: handle, vid, view: 0 };
  renderSheet();
  openLayer($('#sheet'));
  return true;
}

/* ---------- colourway swatches on cards ---------- */
const cwSel = {};
function cwOf(p){ return variant(p, cwSel[p.id]) || p.v.find(x => x.available) || p.v[0]; }
function cardImgs(p, x){
  const idx = (x && x.imgs) || [0, 1];
  const f = p.images[idx[0]], b = idx.length > 1 && idx[1] < p.images.length && (!x || !x.imgs || x.imgs.length > 1) ? p.images[idx[1]] : null;
  return { f, b };
}
function swapImg(img, src){
  if (!img || !src || img.getAttribute('src') === src) return false;
  img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = src; return true;
}
function syncCw(card, p){
  const cur = cwOf(p); if (!cur) return;
  const { f, b } = cardImgs(p, cur);
  const fi = $('.card-media img.f', card), bi = $('.card-media img.b', card);
  if (f && swapImg(fi, f.card) && !card.classList.contains('peek') && !reducedMotion()) fi.animate([{ opacity:0 }, { opacity:1 }], { duration:350, easing:'ease-out' });
  if (bi && b && !card.classList.contains('peek')) swapImg(bi, b.card);
  const hit = $('.card-hit', card); if (hit) hit.dataset.vid = cur.id;
  $$('.cw', card).forEach(s => s.setAttribute('aria-pressed', String(Number(s.dataset.vid) === cur.id)));
  const name = $('.cw-name', card); if (name) name.textContent = cur.label;
}
function pickCw(btn){
  const p = BY[btn.dataset.cw], x = variant(p, btn.dataset.vid); if (!x || !x.available) return;
  cwSel[p.id] = x.id;
  syncCw(btn.closest('.card'), p);
}
// hovering a swatch previews that colourway from its second (three-quarter) photo
document.addEventListener('pointerover', e => {
  if (e.pointerType !== 'mouse' || !e.target.closest) return;
  const s = e.target.closest('[data-cw]');
  if (s){
    const card = s.closest('.card'), p = BY[s.dataset.cw], x = variant(p, s.dataset.vid); if (!x) return;
    const { b, f } = cardImgs(p, x), bi = $('.card-media img.b', card);
    if (bi) swapImg(bi, (b || f).card);
    card.classList.add('peek');
    return;
  }
  const hit = e.target.closest('.card-hit[data-vid]');
  if (hit){
    const card = hit.closest('.card'), p = BY[hit.dataset.open];
    if (p && !card.classList.contains('peek')){ const { b } = cardImgs(p, cwOf(p)); if (b) swapImg($('.card-media img.b', card), b.card); }
  }
});
document.addEventListener('pointerout', e => {
  if (e.pointerType !== 'mouse' || !e.target.closest) return;
  const s = e.target.closest('[data-cw]');
  if (s && !s.contains(e.relatedTarget)) s.closest('.card').classList.remove('peek');
});

/* ---------- shop filters ---------- */
function initFilters(){
  const bar = $('[data-filters]'), grid = $('#grid');
  if (!bar || !grid) return null;
  const cards = $$('.card', grid);
  const tokens = c => (c._t ||= new Set((c.dataset.match || '').toLowerCase().split(/[^\p{L}\p{N}]+/u).filter(Boolean)));
  const keys = chip => (chip.dataset.keys || '').toLowerCase().split(',').map(s => s.trim()).filter(Boolean);
  const hit = (c, chip) => chip.dataset.filter === 'all' || keys(chip).some(k => /[^\p{L}\p{N}]/u.test(k) ? (c.dataset.match || '').toLowerCase().includes(k) : tokens(c).has(k));
  $$('[data-filter]', bar).forEach(chip => {
    const n = cards.filter(c => hit(c, chip)).length;
    const nEl = $('.n', chip); if (nEl) nEl.textContent = dg(n);
    if (!n && chip.dataset.filter !== 'all') chip.hidden = true;
  });
  const apply = key => {
    const chip = $$('[data-filter]', bar).find(c => c.dataset.filter === key && !c.hidden) || $('[data-filter="all"]', bar);
    $$('[data-filter]', bar).forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
    cards.forEach(c => { c.hidden = !hit(c, chip); });
    return chip.dataset.filter === key;
  };
  bar.addEventListener('click', e => { const c = e.target.closest('[data-filter]'); if (c) apply(c.dataset.filter); });
  return apply;
}
const applyFilter = initFilters();
function filterFromHash(){
  const m = location.hash.match(/^#shop=([\w-]+)/);
  if (m && applyFilter){ applyFilter(m[1]); $('#shop')?.scrollIntoView(); }
}

/* ---------- product page ---------- */
function initPdp(){
  const root = $('[data-pdp]'); if (!root) return;
  const p = BY[root.dataset.pdp]; if (!p) return;
  const main = $('#pdp-main'), thumbs = $('#pdp-thumbs'), price = $('#pdp-price'), add = $('#pdp-add');
  let current = variant(p, ($('#pdp-sizes input:checked') || {}).value) || p.v.find(x => x.available) || p.v[0];
  const show = i => {
    const im = p.images[i]; if (!im || !main) return;
    main.className = 'g-main' + (isPhoto(im) ? ' cover' : '');
    main.innerHTML = `<img src="${esc(im.src)}" alt="${esc(im.alt || p.title)}">`;
    if (thumbs) $$('[data-pdp-view]', thumbs).forEach(b => b.setAttribute('aria-current', String(Number(b.dataset.pdpView) === i)));
  };
  const visibleThumbs = () => {
    if (!thumbs || p.colour < 0 || !current || !current.imgs) return;
    $$('[data-pdp-view]', thumbs).forEach(b => { b.hidden = !current.imgs.includes(Number(b.dataset.pdpView)); });
  };
  const update = () => {
    if (!current) return;
    if (price) price.textContent = money(current.price);
    if (add){ add.disabled = !current.available; add.innerHTML = current.available ? `${esc(t('add'))} · ${money(current.price)}` : esc(t('sold_out')); }
    if (p.colour >= 0 && current.imgs){ show(current.imgs[0]); visibleThumbs(); }
    if (history.replaceState && current.id){ const u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u); }
  };
  root.addEventListener('change', e => { if (e.target.name === 'id'){ current = variant(p, e.target.value) || current; update(); } });
  thumbs?.addEventListener('click', e => { const b = e.target.closest('[data-pdp-view]'); if (b) show(Number(b.dataset.pdpView)); });
  visibleThumbs();
  if (p.colour >= 0 && current && current.imgs) show(current.imgs[0]);
}
initPdp();

/* ---------- events ---------- */
document.addEventListener('click', e => {
  const q = s => e.target.closest(s);
  let el;
  if ((el = q('[data-cw]'))) { pickCw(el); return; }
  if ((el = q('[data-open]'))) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    if (BY[el.dataset.open]) { e.preventDefault(); openSheet(el.dataset.open, el.dataset.vid); }
    return;
  }
  // on the cart page the page itself is the bag: follow the link so the two never disagree
  if ((el = q('[data-bag-open]'))) { if (document.body.classList.contains('template-cart')) return; e.preventDefault(); $('#toast')?.classList.remove('on'); openBag(); return; }
  if ((el = q('[data-close]'))) { closeLayer(); return; }
  if ((el = q('[data-close-go]'))) { closeLayer(true); return; }
  if (e.target.id === 'scrim') { closeLayer(); return; }
  if ((el = q('[data-filter-go]')) && applyFilter) {
    if (applyFilter(el.dataset.filterGo)){ e.preventDefault(); $('#shop')?.scrollIntoView(); }
    return;
  }
  if ((el = q('[data-view]'))) { sheet.view = Number(el.dataset.view); renderSheet(); return; }
  if ((el = q('#sheet-add'))) { if (sheet.vid) addToBag(sheet.id, sheet.vid, el); return; }
  if ((el = q('[data-qty]'))) { changeLine(el.dataset.key, Math.max(0, Math.min(99, Number(el.dataset.q) + Number(el.dataset.qty)))); return; }
  if ((el = q('[data-remove]'))) { changeLine(el.dataset.remove, 0); return; }
  if ((el = q('.menu-btn'))) { toggleMenu(); return; }
  if ((el = q('#menu a'))) { toggleMenu(false); return; }
  if ((el = q('#copy-email'))) { copyEmail(el); return; }
});
document.addEventListener('change', e => {
  const fs = e.target.closest('fieldset');
  if (!fs || e.target.type !== 'radio' || fs.id !== 'sheet-sizes') return;
  const vid = Number(e.target.value), p = BY[sheet.id];
  sheet.vid = vid;
  if (p && p.colour >= 0){
    sheet.view = 0; cwSel[p.id] = vid;
    const card = $(`#grid .card-hit[data-open="${CSS.escape(p.id)}"]`)?.closest('.card'); if (card) syncCw(card, p);
  }
  renderSheet();
  $(`#sheet-sizes input[value="${vid}"]`)?.focus({ preventScroll:true });
});
// product forms (product page, BAHTH sets) add without leaving the page
document.addEventListener('submit', e => {
  const form = e.target.closest('form[data-mrk-add]'); if (!form) return;
  const id = new FormData(form).get('id'); if (!id) return;
  e.preventDefault();
  addToBag(form.dataset.mrkAdd, Number(id), form.querySelector('[type="submit"]'));
});
document.addEventListener('keydown', e => {
  if (e.key === 'Escape'){ if (openEl) closeLayer(); else if (rack && rack.isOpen()) rack.close(); else if ($('#menu') && !$('#menu').hidden) toggleMenu(false); }
  const trap = openEl || (rack && rack.isOpen() ? rack.overlay : null);
  if (e.key === 'Tab' && trap){
    const f = $$('button:not([disabled]),a[href],input:not([disabled]),select,textarea', trap).filter(x => x.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  }
});
async function copyEmail(btn){
  const el = $('#email'); if (!el) return;
  try { await navigator.clipboard.writeText(el.textContent.trim()); btn.textContent = t('copied'); }
  catch (err){ const r = document.createRange(); r.selectNodeContents(el); const s = getSelection(); s.removeAllRanges(); s.addRange(r); }
  setTimeout(() => { btn.textContent = t('copy'); }, 1800);
}
window.addEventListener('pageshow', e => { if (e.persisted) Bag.fetch().then(() => renderBag()).catch(() => {}); });


/* ---------- the rack: garments hang side-on and turn to face you on hover ---------- */
const NF = 20;
const RACK_ORDER = ['tees', 'jerseys', 'fleece', 'outerwear', 'other'];

// Plays a pre-rendered turn sequence on a canvas, cross-fading neighbouring frames.
class Scrubber {
  constructor(canvas, urls){ this.c = canvas; this.urls = urls; this.f = []; this.pos = 0; this.from = 0; this.target = 0; this.start = 0; this.dur = 0; this.raf = 0; this.loaded = false; this.tick = this.tick.bind(this); this.f[0] = this.load(0); }
  preload(){ if (this.loaded) return; this.loaded = true; for (let i = 1; i < this.urls.length; i++) this.f[i] = this.f[i] || this.load(i); }
  to(p, instant){
    this.preload();
    const last = this.urls.length - 1; this.target = p * last;
    if (instant){ cancelAnimationFrame(this.raf); this.raf = 0; this.pos = this.target; this.paint(); return; }
    this.from = this.pos; this.start = performance.now(); this.dur = 900 * Math.abs(this.target - this.from) / last;
    if (!this.raf) this.raf = requestAnimationFrame(this.tick);
  }
  tick(now){
    const x = this.dur ? Math.min(1, (now - this.start) / this.dur) : 1;
    this.pos = this.from + (this.target - this.from) * easeIO(x); this.paint();
    this.raf = x < 1 ? requestAnimationFrame(this.tick) : 0;
  }
  load(i){
    const img = new Image(); img.decoding = 'async'; img.src = this.urls[i];
    if (img.decode) img.decode().catch(() => {});
    img.onload = () => { if (this.c.width !== img.naturalWidth){ this.c.width = img.naturalWidth; this.c.height = img.naturalHeight; } if (Math.abs(i - this.pos) < 1) this.paint(); };
    return img;
  }
  ready(i){ const f = this.f[i]; return !!f && f.complete && f.naturalWidth > 0; }
  nearest(i){ for (let d = 0; d < this.urls.length; d++){ if (this.ready(i - d)) return this.f[i - d]; if (this.ready(i + d)) return this.f[i + d]; } }
  paint(){
    const ctx = this.c.getContext('2d'); if (!ctx) return;
    const lo = Math.floor(this.pos), hi = Math.min(lo + 1, this.urls.length - 1), mix = this.pos - lo;
    const a = this.nearest(lo); if (!a) return;
    const { width:w, height:h } = this.c;
    ctx.clearRect(0, 0, w, h); ctx.globalAlpha = 1; ctx.drawImage(a, 0, 0, w, h);
    if (mix > .01 && hi !== lo && this.ready(hi)){ ctx.globalAlpha = mix; ctx.drawImage(this.f[hi], 0, 0, w, h); ctx.globalAlpha = 1; }
  }
}

const rack = (() => {
  const root = $('#mrk'); if (!root) return null;
  let conf = { base: '', items: [] };
  try { conf = JSON.parse($('script[data-mrk-rack]').textContent); } catch (e) { return null; }
  const base = conf.base || CFG.assets || '';
  const rackFrame = (key, i) => `${base}rack-${key}-${String(i).padStart(2, '0')}.webp`;
  const flat = (key, side) => `${base}rack-${key}-${side}.webp`;
  // one entry per piece on the rail
  const items = (conf.items || []).filter(r => BY[r.handle]).map(r => ({ key: r.frames, type: RACK_ORDER.includes(r.type) ? r.type : 'other', p: BY[r.handle] }));
  if (!items.length){ root.closest('.rack-sec')?.setAttribute('hidden', ''); return null; }

  const hangers = $('.mrk-hangers', root), caption = $('.mrk-caption', root);
  const cta = $('.mrk-cta', root), turnBtn = $('.mrk-turn', root), railBox = $('.mrk-rack', root), filterBar = $('#mrk-filters');
  const overlay = $('.mrk-detail', root), stage = $('.mrk-detail-stage', root), scroller = $('.mrk-wallscroll', root);
  const dock = $('.mrk-dock', root);
  const titleOf = it => it.p.title;
  const railIdx = items.map((_, i) => i);
  const types = ['all', ...RACK_ORDER.filter(ty => items.some(it => it.type === ty))];
  const slots = [], scrub = [], timers = [];
  let hovered = -1, detail = -1, busy = false, lastPointer = 'mouse', vid = null, warmed = false, pendingClose = false;
  // Escape or Close pressed mid-animation closes as soon as the animation ends
  const settle = () => { busy = false; if (pendingClose){ pendingClose = false; close(); } };
  let type = 'all', visible = railIdx.slice();
  railBox.style.setProperty('--n', railIdx.length);

  railIdx.forEach(i => {
    const it = items[i];
    const slot = document.createElement('button');
    slot.type = 'button'; slot.className = 'mrk-slot'; slot.dataset.i = i;
    slot.innerHTML = `<span class="mrk-sway" style="--sway-d:${(4 + Math.random()*2).toFixed(2)}s;--sway-o:-${(Math.random()*6).toFixed(2)}s"><span class="mrk-kick"><span class="mrk-fig"><span class="mrk-flip"><canvas class="mrk-frames" width="640" height="640"></canvas></span></span></span></span>`;
    hangers.append(slot); slots[i] = slot;
    scrub.push(new Scrubber($('canvas', slot), Array.from({ length:NF }, (_, k) => rackFrame(it.key, k))));
  });

  // Garment size is set by the full rail (so a filter never makes pieces bigger or smaller);
  // a filtered group hangs centred, a little more spread out, with some room either side.
  function geometry(){
    const W = hangers.clientWidth, s0 = W / railIdx.length, k = Math.max(visible.length, 1);
    const s = Math.min(W / k, s0 * 1.8), gw = k * s, x0 = (W - gw) / 2, pad = k === railIdx.length ? 0 : s0 * 1.5;
    return { W, s0, s, x0, gw, open: Math.min(s0 * 3.65, W * .35), lo: Math.max(0, x0 - pad), hi: Math.min(W, x0 + gw + pad) };
  }

  // Where every visible garment should hang when slot h faces front: { slot: [centre, width] }.
  // The turned garment stays on its own hook; the others are pushed out and squeezed
  // into the room left on each side, tucking behind each other near the ends.
  function plan(h){
    const g = geometry(), k = visible.length, out = {};
    const hj = visible.indexOf(h);
    if (hj < 0){ visible.forEach((i, j) => { out[i] = [g.x0 + (j + .5) * g.s, g.s]; }); return out; }
    const min = g.s * .55, xh = g.x0 + (hj + .5) * g.s, r = k - 1 - hj;
    let leftSpan = xh - g.open / 2 - g.lo; if (leftSpan < hj * min) leftSpan = Math.min(hj * min, xh - g.lo - g.s * .35);
    let rightSpan = g.hi - (xh + g.open / 2); if (rightSpan < r * min) rightSpan = Math.min(r * min, g.hi - xh - g.s * .35);
    const left = leftSpan / Math.max(hj, 1), right = rightSpan / Math.max(r, 1);
    visible.forEach((i, j) => { out[i] = j < hj ? [g.lo + (j + .5) * left, left] : j > hj ? [g.hi - rightSpan + (j - hj - .5) * right, right] : [xh, g.open]; });
    return out;
  }
  function layout(){
    if (!hangers.clientWidth) return;
    const p = plan(hovered);
    Object.entries(p).forEach(([i, [x, w]]) => { slots[i].style.setProperty('--x', `${x}px`); slots[i].style.setProperty('--w', `${w}px`); });
  }

  // The garment under the pointer, read from where the garments are going to hang
  // (not from the sliding animation, which would make the rack flicker). A squeezed
  // neighbour wins over the turned garment's wide zone, so every piece is exactly
  // one step away in both directions and none get skipped.
  function garmentAt(clientX){
    const g = geometry();
    const x = clientX - hangers.getBoundingClientRect().left;
    if (!g.W || x < g.lo || x > g.hi) return -1;
    const p = plan(hovered), inZone = i => Math.abs(x - p[i][0]) <= p[i][1] / 2;
    for (const i of visible) if (i !== hovered && inZone(i)) return i;
    if (hovered >= 0 && p[hovered] && inZone(hovered)) return hovered;
    let best = -1, d = Infinity;
    for (const i of visible){ const dd = Math.abs(x - p[i][0]); if (dd < d){ d = dd; best = i; } }
    return best;
  }

  function kick(i){
    if (reducedMotion()) return;
    const j0 = visible.indexOf(i); if (j0 < 0) return;
    [[visible[j0 - 1], -1], [visible[j0 + 1], 1]].forEach(([j, dir]) => {
      const k = j !== undefined && $('.mrk-kick', slots[j]); if (!k) return;
      k.animate([0, 1.8*dir, -.8*dir, .3*dir, 0].map(d => ({ transform:`rotate(${d}deg)` })), { duration:1600, easing:'ease-in-out' });
    });
  }

  function setCta(){
    const on = hovered >= 0;
    turnBtn.hidden = !on;
    if (on){
      const it = items[hovered];
      caption.textContent = `${titleOf(it)} · ${money(it.p.price)}`;
      turnBtn.innerHTML = `<span aria-hidden="true">↻</span> ${esc(t('rack_back'))}`;
      cta.innerHTML = `${esc(t('rack_cta_one'))} <span aria-hidden="true">→</span>`;
    } else cta.innerHTML = `${esc(t('rack_cta_all'))} <span aria-hidden="true">↓</span>`;
  }

  function hover(i){
    if (detail >= 0 || i === hovered) return;
    const prev = hovered; hovered = i;
    if (prev >= 0){ slots[prev].classList.remove('is-open'); scrub[prev].to(0, reducedMotion()); }
    if (i >= 0){ clearTimeout(timers[i]); slots[i].classList.add('is-open'); scrub[i].to(1, reducedMotion()); kick(i); }
    root.classList.toggle('is-hovering', i >= 0);
    setCta(); layout();
  }

  // the back print is shown in the close-up, from the flat product photos, so front and back share one scale
  function turnAround(){ if (hovered >= 0) open(hovered, true); }

  const navList = () => visible;
  function fill(i, flipped){
    const it = items[i], p = it.p;
    if (vid && !variant(p, vid)) vid = null;
    const avail = p.v.filter(x => x.available);
    if (!vid && avail.length === 1 && p.v.length === 1) vid = avail[0].id;
    // flat product shots, no hanger; the hanging frame sits on top only while the piece flies in or out
    stage.innerHTML = `<div class="mrk-fig is-detail${flipped ? ' is-flipped' : ''}"><span class="mrk-flip"><img class="mrk-flat" src="${esc(flat(it.key, 'front'))}" alt="${esc(titleOf(it))}, ${esc(t('front'))}"><img class="mrk-flat mrk-flat-back" src="${esc(flat(it.key, 'back'))}" alt="${esc(titleOf(it))}, ${esc(t('back'))}"></span><img class="mrk-hang" src="${esc(rackFrame(it.key, NF - 1))}" alt="" aria-hidden="true"></div>`;
    const nav = navList(), j = nav.indexOf(i);
    $('.mrk-count', overlay).textContent = `${dg(String(j + 1).padStart(2, '0'))} / ${dg(String(nav.length).padStart(2, '0'))}`;
    $('.mrk-title', overlay).textContent = p.title;
    $('.mrk-price', overlay).textContent = money(p.price);
    const sizes = $('#rack-sizes');
    sizes.hidden = p.single;
    sizes.innerHTML = p.single ? '' : chips(p, 'rack', vid);
    setAdd(); setDetailTurn();
    $('#rack-details').innerHTML = `${esc(t('details'))} <span class="arrow" aria-hidden="true">→</span>`;
    $('.mrk-prev', overlay).setAttribute('aria-label', t('prev'));
    $('.mrk-next', overlay).setAttribute('aria-label', t('next'));
  }
  function setAdd(){
    const p = items[detail].p, b = $('#rack-add');
    const avail = p.v.some(x => x.available);
    b.disabled = !vid || !avail;
    b.innerHTML = !avail ? esc(t('sold_out')) : vid ? `${esc(t('add'))} · ${money((variant(p, vid) || p).price)}` : esc(t('choose'));
  }
  const detailFlipped = () => !!$('.mrk-fig.is-flipped', stage);
  function setDetailTurn(){
    $('#rack-turn').innerHTML = `<span aria-hidden="true">↻</span> ${esc(t(detailFlipped() ? 'rack_front' : 'rack_back'))}`;
  }
  function turnDetail(){ const f = $('.mrk-fig', stage); if (!f || busy) return; f.classList.toggle('is-flipped'); setDetailTurn(); }

  const source = i => $('.mrk-fig', slots[i]);
  const sourceRect = i => $('.mrk-flip', slots[i]).getBoundingClientRect();
  async function flip(fig, rect, reverse, dest){
    // fade the flat photos themselves: an opacity animation on the 3D turn wrapper would flatten it
    // and the back photo would never show (you'd see the front mirrored instead)
    const hang = $('.mrk-hang', fig), flats = $$('.mrk-flat', fig);
    if (reducedMotion()){ if (hang) hang.style.opacity = 0; if (dest) dest.style.visibility = ''; return; }
    const to = fig.getBoundingClientRect(); if (!to.height) return;
    const s = rect.height / to.height, dx = rect.left + rect.width / 2 - (to.left + to.width / 2), dy = rect.top - to.top;
    const frames = [{ transform:`translate(${dx}px, ${dy}px) scale(${s})`, transformOrigin:'50% 0' }, { transform:'none', transformOrigin:'50% 0' }];
    const o = { duration:520, easing:'cubic-bezier(.22,1,.36,1)', fill:'forwards' };
    const fades = [];
    if (!reverse){
      // picked: the hanging photo melts into the flat shots while the white veil comes up
      if (hang) fades.push(hang.animate([{ opacity:1 }, { opacity:0 }], o));
      flats.forEach(f => fades.push(f.animate([{ opacity:0 }, { opacity:1 }], o)));
    } else {
      // put back: the flat shots melt into the piece on its own hook, which blends into the wall
      // like every garment on the rail (the white-backed hanging photo is not used on the way back)
      const late = { duration:520, easing:'linear', fill:'forwards' };
      flats.forEach(f => fades.push(f.animate([{ opacity:1 }, { opacity:1, offset:.3 }, { opacity:0, offset:.85 }, { opacity:0 }], late)));
      if (dest){ dest.style.visibility = ''; fades.push(dest.animate([{ opacity:0 }, { opacity:0, offset:.3 }, { opacity:1, offset:.85 }, { opacity:1 }], late)); }
    }
    await fig.animate(reverse ? frames.reverse() : frames, o).finished;
    if (!reverse) fades.forEach(a => a.cancel());   // back to the stylesheet: hanging layer hidden, photos shown
    else if (dest) fades[fades.length - 1].cancel();  // the piece on the rack keeps its own (full) opacity
  }

  async function open(i, back){
    if (busy || detail >= 0) return;
    busy = true; detail = i; vid = null;
    const src = source(i), from = sourceRect(i);
    fill(i, !!back);
    overlay.hidden = false; root.dataset.state = 'detail';
    document.documentElement.style.overflow = 'hidden';
    src.style.visibility = 'hidden';
    await Promise.all($$('img', stage).map(img => img.complete ? 0 : new Promise(r => { img.onload = img.onerror = r; setTimeout(r, 700); })));
    await flip(stage.firstElementChild, from, false);
    $('.mrk-close', overlay).focus({ preventScroll:true });
    settle();
  }

  function reset(i, keep){
    source(i).style.visibility = '';
    overlay.hidden = true; stage.innerHTML = ''; root.dataset.state = 'idle';
    document.documentElement.style.overflow = '';
    detail = -1; busy = false; pendingClose = false;
    if (keep){
      // back on its hook, still facing you, as it was before you picked it; with a mouse that has
      // moved off the rail, it then turns back to the side by itself, like any piece you stop hovering
      setCta(); layout();
      if (lastPointer === 'mouse') setTimeout(() => {
        if (detail >= 0 || hovered !== i) return;
        const over = document.elementFromPoint(lastX, lastY);
        hover(over && hangers.contains(over) ? garmentAt(lastX) : -1);
      }, 450);
      return;
    }
    hovered = -1;
    slots.forEach((s, j) => { clearTimeout(timers[j]); s.classList.remove('is-open', 'is-flipped'); scrub[j].to(0, true); });
    root.classList.remove('is-hovering'); setCta(); layout();
  }
  // the piece about to go back faces the front on its own hook, as when it was picked;
  // after browsing to another piece in the close-up, that one takes its place instantly (it is behind the veil)
  function faceFront(i){
    if (hovered === i) return;
    hangers.classList.remove('is-live');
    if (hovered >= 0){ slots[hovered].classList.remove('is-open'); scrub[hovered].to(0, true); }
    hovered = i; slots[i].classList.add('is-open'); scrub[i].to(1, true);
    root.classList.add('is-hovering'); setCta(); layout();
    void hangers.offsetWidth; hangers.classList.add('is-live');
  }
  async function close(instant){
    if (detail < 0) return;
    if (busy && !instant){ if (root.dataset.state === 'detail') pendingClose = true; return; }
    const i = detail;
    if (!instant){
      busy = true;
      faceFront(i);
      root.dataset.state = 'closing';
      const fig = stage.firstElementChild;
      fig.classList.remove('is-flipped');   // showing the back? it turns to the front on the way
      await flip(fig, sourceRect(i), true, source(i));
    }
    reset(i, !instant);
    if (!instant) slots[i].focus({ preventScroll:true });
  }

  async function step(dir){
    if (busy || detail < 0) return;
    busy = true;
    const nav = navList(), k = nav.length, old = stage.firstElementChild;
    const o = { duration: reducedMotion() ? 0 : 180, easing:'ease-in', fill:'forwards' };
    await old.animate([{ opacity:1 }, { opacity:0, transform:`translateX(${-14*dir}px)` }], o).finished;
    source(detail).style.visibility = '';
    detail = nav[(nav.indexOf(detail) + dir + k) % k]; vid = null;
    source(detail).style.visibility = 'hidden';
    fill(detail, false);
    await stage.firstElementChild.animate([{ opacity:0, transform:`translateX(${14*dir}px)` }, { opacity:1, transform:'none' }], { ...o, duration: reducedMotion() ? 0 : 260, easing:'cubic-bezier(.22,1,.36,1)' }).finished;
    settle();
  }

  // ---- events ----
  root.addEventListener('pointerdown', e => { lastPointer = e.pointerType; });
  let lastX = -1, lastY = -1;
  document.addEventListener('pointermove', e => { lastX = e.clientX; lastY = e.clientY; }, { passive:true });
  hangers.addEventListener('pointermove', e => { if (e.pointerType === 'mouse') hover(garmentAt(e.clientX)); });
  // leaving the rail downwards (to the buttons under it) keeps the piece turned
  railBox.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && !root.classList.contains('is-docked')) hover(-1); });
  // with the buttons docked under the scrollbar, the piece stays turned until the mouse leaves the whole wall
  $('.mrk-scene', root).addEventListener('pointerleave', e => { if (e.pointerType === 'mouse' && root.classList.contains('is-docked')) hover(-1); });
  hangers.addEventListener('click', e => {
    const slot = e.target.closest('.mrk-slot');
    const i = e.detail === 0 ? Number(slot ? slot.dataset.i : -1) : garmentAt(e.clientX);
    if (i < 0) return;
    if (lastPointer !== 'mouse' && hovered !== i) return hover(i); // touch: first tap turns, second opens
    open(i);
  });
  // keyboard focus turns a piece like hover does; a tap's focus must not, or the first tap would open it
  slots.forEach((s, i) => {
    s.addEventListener('focus', () => { if (s.matches(':focus-visible')) hover(i); });
    s.addEventListener('blur', e => {
      if (e.relatedTarget && (railBox.contains(e.relatedTarget) || dock.contains(e.relatedTarget)) && !e.relatedTarget.classList.contains('mrk-slot')) return;
      if (hovered === i && (lastPointer === 'mouse' || s.matches(':focus-visible'))) hover(-1);
    });
  });
  turnBtn.addEventListener('click', turnAround);
  cta.addEventListener('click', () => {
    if (hovered >= 0) return open(hovered);
    const shop = $('#shop');
    if (shop) shop.scrollIntoView(); else location.href = `${(ROUTES.root || '/').replace(/\/$/, '')}/collections/all`;
  });
  stage.addEventListener('click', turnDetail);
  $('#rack-turn').addEventListener('click', turnDetail);
  $('.mrk-close', overlay).addEventListener('click', () => close());
  $('.mrk-prev', overlay).addEventListener('click', () => step(-1));
  $('.mrk-next', overlay).addEventListener('click', () => step(1));
  $('#rack-add').addEventListener('click', e => { if (vid && detail >= 0) addToBag(items[detail].p.id, vid, e.currentTarget); });
  $('#rack-details').addEventListener('click', () => { const id = items[detail].p.id; close(true); openSheet(id); });
  $('#rack-sizes').addEventListener('change', e => {
    if (e.target.type !== 'radio') return;
    vid = Number(e.target.value); setAdd();
  });

  // ---- type filter above the rail ----
  function renderFilter(){
    if (!filterBar) return;
    filterBar.hidden = types.length < 3;
    filterBar.innerHTML = types.map(ty => {
      const n = ty === 'all' ? items.length : items.filter(it => it.type === ty).length;
      return `<button class="chip" type="button" data-type="${ty}" aria-pressed="${type === ty}">${esc(t('rf_' + ty))}<span class="n">${dg(n)}</span></button>`;
    }).join('');
  }
  function setFilter(ty){
    if (detail >= 0 || ty === type) return;
    hover(-1);
    type = ty;
    visible = railIdx.filter(i => ty === 'all' || items[i].type === ty);
    slots.forEach((s, i) => { const on = visible.includes(i); s.classList.toggle('is-out', !on); s.tabIndex = on ? 0 : -1; s.setAttribute('aria-hidden', String(!on)); });
    layout(); renderFilter();
    // keep what is on show in view where the wall is wider than the screen
    requestAnimationFrame(() => {
      const sr = scroller.getBoundingClientRect(), g = geometry(), hr = hangers.getBoundingClientRect();
      const c = hr.left + g.x0 + g.gw / 2;
      scroller.scrollBy({ left: c - (sr.left + sr.width / 2), behavior: reducedMotion() ? 'auto' : 'smooth' });
    });
  }
  filterBar?.addEventListener('click', e => { const b = e.target.closest('[data-type]'); if (b) setFilter(b.dataset.type); });
  document.addEventListener('keydown', e => {
    if (detail < 0 || openEl) return;
    if (e.key === 'ArrowLeft') step(-1);
    if (e.key === 'ArrowRight') step(1);
  });

  // load every turn sequence once the rack is near the screen
  function warm(){
    if (warmed) return; warmed = true;
    scrub.forEach(s => s.preload());
  }
  new IntersectionObserver((en, ob) => { if (en[0].isIntersecting){ warm(); ob.disconnect(); } }, { rootMargin:'600px 0px' }).observe(root);
  root.addEventListener('pointerenter', warm, { once:true });

  // ---- phones and tablets: a scrollbar under the rail, with the caption and buttons
  // centred under it so they stay put while the wall slides sideways ----
  const ctaBox = $('.mrk-ctas', root), bar = $('.mrk-bar', root), thumb = $('.mrk-thumb', root), scene = $('.mrk-scene', root);
  const dockMQ = matchMedia('(max-width: 760px), (hover: none)');
  let barRAF = 0, drag = null;
  function syncBar(){
    cancelAnimationFrame(barRAF);
    barRAF = requestAnimationFrame(() => {
      if (!root.classList.contains('is-docked')) return;
      const max = scroller.scrollWidth - scroller.clientWidth, tw = bar.clientWidth;
      bar.classList.toggle('is-idle', max <= 1);
      if (max <= 1 || !tw) return;
      const w = Math.max(40, tw * scroller.clientWidth / scroller.scrollWidth);
      thumb.style.width = `${w}px`;
      thumb.style.transform = `translateX(${(tw - w) * Math.min(1, Math.max(0, scroller.scrollLeft / max))}px)`;
      // sit just under the garments, whatever the screen height
      const hr = hangers.getBoundingClientRect(), sr = scene.getBoundingClientRect();
      if (hr.height) dock.style.setProperty('--dock-top', `${Math.round(hr.top - sr.top + hr.height * .84)}px`);
    });
  }
  function placeDock(){
    const on = dockMQ.matches;
    root.classList.toggle('is-docked', on);
    if (on && caption.parentNode !== dock) dock.append(caption, ctaBox);
    if (!on && caption.parentNode !== railBox) railBox.append(caption, ctaBox);
    syncBar();
  }
  scroller.addEventListener('scroll', syncBar, { passive:true });
  new ResizeObserver(syncBar).observe(scene);
  dockMQ.addEventListener('change', placeDock);
  // drag the thumb, or touch the bar anywhere to jump there and keep dragging
  bar.addEventListener('pointerdown', e => {
    const max = scroller.scrollWidth - scroller.clientWidth; if (max <= 1) return;
    const r = bar.getBoundingClientRect(), w = thumb.offsetWidth, ratio = max / Math.max(r.width - w, 1);
    if (e.target !== thumb) scroller.scrollLeft = (e.clientX - r.left - w / 2) * ratio;
    drag = { x: e.clientX, s: scroller.scrollLeft, ratio };
    bar.setPointerCapture(e.pointerId); bar.classList.add('is-dragging');
    e.preventDefault();
  });
  bar.addEventListener('pointermove', e => { if (drag) scroller.scrollLeft = drag.s + (e.clientX - drag.x) * drag.ratio; });
  const endDrag = () => { drag = null; bar.classList.remove('is-dragging'); };
  bar.addEventListener('pointerup', endDrag);
  bar.addEventListener('pointercancel', endDrag);
  placeDock();

  layout();
  requestAnimationFrame(() => { hangers.classList.add('is-live'); scroller.scrollLeft = (scroller.scrollWidth - scroller.clientWidth) / 2; syncBar(); });
  new ResizeObserver(() => layout()).observe(hangers);

  function relabel(){
    items.forEach((it, i) => slots[i].setAttribute('aria-label', `${titleOf(it)}, ${money(it.p.price)}`));
    const intro = $('#mrk-intro'), hov = hoverable();
    if (intro){
      $('.mrk-h', root).textContent = hov ? intro.dataset.hHover : intro.dataset.hTouch;
      $('.mrk-hint', root).textContent = hov ? intro.dataset.pHover : intro.dataset.pTouch;
    }
    renderFilter();
    setCta();
  }
  relabel();
  return { isOpen: () => detail >= 0, close, overlay, _debug: { garmentAt: x => garmentAt(x), hovered: () => hovered, plan } };
})();

/* ---------- Eastern Arabic numerals in the Arabic store ---------- */
if (lang === 'ar') $$('[data-digits]').forEach(el => {
  const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  while (w.nextNode()) w.currentNode.nodeValue = dg(w.currentNode.nodeValue);
});
setCount(false);
filterFromHash();
window.addEventListener('hashchange', filterFromHash);
/* ---------- BAHTH wordmark: shrink to its column if a fallback font runs wide ---------- */
function fitMark(){
  document.querySelectorAll('.bd-word').forEach(w => {
    w.style.fontSize = '';
    const r = w.clientWidth / w.scrollWidth;
    if (r < 1) w.style.fontSize = (parseFloat(getComputedStyle(w).fontSize) * r * 0.98) + 'px';
  });
}
fitMark();
if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitMark);
window.addEventListener('resize', fitMark);

/* ---------- BAHTH one-offs: "Enquire" opens a short form, the visitor's email is required ---------- */
(() => {
  const d = $('#enquire'); if (!d) return;
  const title = $('#enq-title', d), deck = $('#enq-deck', d), img = $('#enq-img', d);
  const fill = (name, src) => {
    title.textContent = name || ''; if (deck) deck.value = name || '';
    img.hidden = !src; if (src) img.src = src;
  };
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-enquire]'); if (!b) return;
    const src = b.closest('.single')?.querySelector('img')?.currentSrc || '';
    fill(b.dataset.enquire, src);
    d.classList.remove('is-sent');
    try { sessionStorage.setItem('mrk-enquiry', JSON.stringify([b.dataset.enquire, src])); } catch (_) {}
    openLayer(d);
  });
  // back from Shopify after sending (or with an error): reopen on the note, for the same deck
  if (location.hash === '#enquire-form' && $('[data-enq-done], [data-enq-error]', d)){
    let saved = []; try { saved = JSON.parse(sessionStorage.getItem('mrk-enquiry') || '[]'); } catch (_) {}
    fill(saved[0], saved[1]);
    d.classList.toggle('is-sent', !!$('[data-enq-done]', d) && !$('[data-enq-error]', d));
    openLayer(d);
  }
})();
// theme editor: sections are re-rendered on every change, so start again from a fresh page
if (window.Shopify && window.Shopify.designMode){
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(ev => document.addEventListener(ev, () => location.reload()));
}
})();
